import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApiUrl } from '@brand-lolly/app/_services/base-api-urls';
import { Observable } from 'rxjs';
import {
	CheckoutRequest,
	CheckoutResponse
} from '@brand-lolly/app/billing/types/mutations.types';
import { idempotencyHeaders } from './idempotency.util';

export interface IStartCheckoutService {
	start(request: CheckoutRequest): Observable<CheckoutResponse>;
}

@Injectable({ providedIn: 'root' })
export class StartCheckoutService implements IStartCheckoutService {
	private readonly url = `${BaseApiUrl.SocialMessengerPython}billing/checkout`;

	constructor(private http: HttpClient) {}

	start(request: CheckoutRequest): Observable<CheckoutResponse> {
		return this.http.post<CheckoutResponse>(this.url, request, {
			headers: idempotencyHeaders()
		});
	}
}
